var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"industry"},[_c('div',{staticClass:"head"},[_c('Navigator'),_c('h3',[_vm._v("工业智能化")]),_c('p',[_vm._v("Industrial intelligence")])],1),_c('Content',{attrs:{"data":_vm.content}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }